import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';

@Component({
  selector: 'up-search-collaborator',
  templateUrl: './search-collaborator.component.html',
  styleUrls: ['./search-collaborator.component.scss']
})
export class SearchCollaboratorComponent implements OnInit {
  @Output() emitQuerySearch: EventEmitter<string> = new EventEmitter<string>();

  hasSearch!: boolean;
  formSearch!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.formSearch = this.fb.group({
      search: ['']
    });
    this.initSearch();
    this.onChange();
  }

  initSearch(): void {
    this.formSearch
      .get('search')
      .valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(res => this.emitQuerySearch.emit(res?.trim()))
      )
      .subscribe();
  }

  onChange(): void {
    this.formSearch.get('search').valueChanges.subscribe(res => (res ? (this.hasSearch = true) : (this.hasSearch = false)));
  }
}
